import { useEffect, useMemo } from "react";
import { triggerTrackingClick } from "@tracking/tracking";

const Config = { childList: true };
export const useTrackElementInjected = (
  parentId: string,
  trackingId: string,
): void => {
  const observer = useMemo(
    () =>
      new MutationObserver((mutationList) => {
        for (const mutation of mutationList) {
          if (mutation.type === "childList") {
            triggerTrackingClick(trackingId);
          }
        }
      }),
    [trackingId],
  );
  useEffect(() => {
    const targetNode = document.getElementById(parentId);
    if (targetNode) {
      observer.observe(targetNode as Node, Config);
    }
  }, [parentId, trackingId, observer]);
  useEffect(() => {
    return (): void => {
      observer.disconnect();
    };
  }, [observer]);
};
